import { removeDoubleSlashes } from './remove-double-slashes'

export const shopAsset = (url: string) => removeDoubleSlashes(url)
